import { Divider, Space } from 'component/Space'
import { Spinner } from 'component/Spinner'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { Circle } from 'page/catalog/Circle/Circle'
import { CreateButton } from 'page/catalog/UserModal/step/CreateButton'
import { SearchInput } from 'page/catalog/UserModal/step/SearchInput'
import { UserCard } from 'page/catalog/UserModal/step/UserCard'
import { UserItem } from 'page/catalog/UserModal/step/UserItem'
import { userModal } from 'page/catalog/UserModal/store/UserModalStore'
import { Fragment } from 'react'

export const SearchStep = observer(() => {
  const { data, search } = userModal.it
  const { min, state, clients } = search
  const none = state === 'none'
  const short = state === 'short'
  const invalid = state === 'invalid'
  const busy = state === 'busy'
  const success = state === 'success'
  const empty = success && !clients.length
  const list = success && !!clients.length

  return <Vertical gap={16} margin={[0, -16]} flex="1 1 700px" oh>
    <Vertical pad={[0, 16]}>
      {data && <UserCard />}
    </Vertical>
    <Vertical pad={[0, 16]}>
      <SearchInput />
    </Vertical>
    <Vertical center tall oh>
      {none && <Space />}
      {short && <Typo size={11} error>
        {i18n('EnterAtLeastCountDigits', { count: min })}
      </Typo>}
      {invalid && <Typo size={11} error>
        {i18n('EnterValidEmail')}
      </Typo>}
      {busy && <Spinner />}
      {empty && <Vertical gap={8} center tall>
        <Circle size={32} icon="person_search" />
        <Typo size={13} medium upper>
          {i18n('CustomerNotFound')}
        </Typo>
      </Vertical>}
      {list && <Vertical gap={8} tall wide scroll>
        {clients.map((client, index) => (<Fragment key={client.user_id}>
          {index > 0 && <Divider tertiary />}
          <UserItem data={client} />
        </Fragment>))}
      </Vertical>}
    </Vertical>
    <Vertical pad={[0, 16]}>
      <CreateButton />
    </Vertical>
  </Vertical>
})
